import React from 'react';
import '../assets/css/style.css';


const Header = (title) => {
  console.log(title);
  return (
    <div style={headerStyle}>
      <div style={logoStyle}>
        {/* Replace the 'logo.png' with your actual logo image */}
        <img src="http://18.162.166.6:5010/static/media/MergedImages.0db9022ff0657aa1da6f.png" alt="Logo" style={{ width: '120px', height: '75px' }} />
      </div>
      <div style={brandStyle}>
        {/* <h1 style={{ margin: '0', fontSize: '1.5rem' }}>{ (title && title.title) ? title.title : "Round Details" }</h1> */}
      </div>
      <div style={versionStyle}>
        <span style={{ margin: '0', fontSize: '.8rem' }}>Version : 1.2</span>
      </div>
    </div>
  );
};

const headerStyle = {
  display: 'none',
  backgroundColor: '#333', // Dark background color
  color: '#fff',          // Text color
  padding: '10px',        // Padding for content
  // display: 'flex',        // Use flexbox for layout
  alignItems: 'center',   // Center align items vertically
};

const logoStyle = {
  marginRight: '10px',    // Add some margin to the right of the logo
  display: 'flex',        // Use flexbox for layout
  alignItems: 'center',   // Center align items vertically
  justifyContent: 'center', // Center align items horizontally
};

const brandStyle = {
  flex: '1',              // Allow the brand to take remaining space
};

const  versionStyle = {
  display: "flex",
  justifyContent : 'right',
  alignItems : "bottom"
}

export default Header;
